export default function decode(input: Uint8Array): Uint8Array {
  const evenLengthInput = input.length % 2 === 0 ? input : new Uint8Array([...input, 0x30]);
  const output = new Uint8Array(input.length / 2);
  for (let i = 0; i < evenLengthInput.length; i += 2) {
    const byte = parseInt(String.fromCharCode(evenLengthInput[i], evenLengthInput[i + 1]), 16);
    output[i / 2] = byte;
  }
  return output;
}
